import { IntegrationLogStatus, IntegrationLogType } from "@/types";

export const IntegrationLogStatusColorMap = {
  [IntegrationLogStatus.Success]: "green",
  [IntegrationLogStatus.Failed]: "red",
};

export const IntegrationLogTypeMap = {
  [IntegrationLogType.OrderValidate]: "Order Validation",
  [IntegrationLogType.OrderCreate]: "Submit Order to Cube",
  [IntegrationLogType.OrderSubmit]: "Order Request",
  [IntegrationLogType.OrderQuery]: "Search Order",
  [IntegrationLogType.OrderDelete]: "Delete Order",
  [IntegrationLogType.ShipmentReport]: "EDI Report",
  [IntegrationLogType.CustomerOrderSync]: "Sync 2C Order to Customer",
  [IntegrationLogType.CustomerOrderReport]: "Send 2C Order Report",
  [IntegrationLogType.BusinessOrderReport]: "Send 2B Order Report",
  [IntegrationLogType.StockBatchCreatedReport]: "Create Stock Batch",
  [IntegrationLogType.StockBatchCompletedReport]: "Complete Stock Batch",
  [IntegrationLogType.StockInventorySync]: "Sync Stock Inventory",
  [IntegrationLogType.StockInventoryReport]: "Send Stock Inventory Report",
  [IntegrationLogType.StockInventoryMovementReport]:
    "Send Stock Inventory Movement Report",
};
